import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTips } from "../../../../../common/GlobalTips";
import JSZip from "jszip";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    setGenerateAtom,
    chatLangAtom,
    publishColorInfoAtom,
    cardsAtom,
    modalObjAtom,
    checkImgConfirmAtom,
    selectedImageIndexAtom,
    imageWorkflowsAtom,
    openPaymentInfoAtom,
    rodinGenPipeline,
    subscriptionsInfoAtom,
    taskDetailAtom,
    userPermissionAtom,
    balanceAtom,
    showLoginAtom, logInfoAtom
} from "../../../../../store";
import { getTaskDownload, likeCard, rodinUnlock, uploadToSketchfab, getSketchfabState, rodinHistory } from "../../../../../utils/net";
import { trackEvent } from '../../../../../utils/trackEvent'
import { startFakeProgressBar, doneFakeProgressBar } from "../../utils";
import style from "../../rodingenerateboard.module.css";
import { LockTip } from "../lockTip";
import { WaitingProgress } from "../progressBar";
import { ShakeTips } from "../../../../newRodin/components/ShakeTips";
import * as Sentry from "@sentry/react";
import { useRefreshInfo, useWebSocket } from '../../../../../utils/hooks';
import { driver } from 'driver.js';
import SketchfabOAuth2 from "@sketchfab/oauth2"
import SketIcon from './assets/sketchfablogo.png'
import { BiLoaderAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { PermissionContext } from "../../../../../utils/context";
import Restricted from "../../../../../utils/restricted";
import { Turnstile } from "@marsidev/react-turnstile";
import Switch from './switch';
import { handleCaptchaVerification } from '../../../../../utils/auth';
import ReactGA from "react-ga4";

const globalTimeStamp = process.env.REACT_APP_GLOBAL_TIMESTAMP //TODO:High-poly是否显示

const RodinPack = React.forwardRef((props, ref) => {
    const balance = useRecoilValue(balanceAtom);
    const [isQueued, setIsQueued] = useState(false)
    const [taskDetail, setTaskDetail] = useRecoilState(taskDetailAtom);
    const [imageWorkflows, setImageWorkflows] = useRecoilState(imageWorkflowsAtom);
    const [checkImgConfirm, setCheckImgConfirm] = useRecoilState(checkImgConfirmAtom);
    const [selectedImageIndex, setSelectedImageIndex] = useRecoilState(selectedImageIndexAtom);
    const [highPolyTipBox, setHighPolyTipBox] = useState(false)
    const [mtlTipBox, setMtlTipBox] = useState(false)
    const [geometrySettings, setGeometrySettings] = useState({
        geometry: 'Base Model',
        fileFormat: '.obj',
    })
    const [materialSettings, setMaterialSettings] = useState({
        material: ["PBR", "Shaded"],
        materialDpis: '2K',
    })
    const tip = useTips()
    const zip = useRef(new JSZip())
    const geometrySets = ['Base Model', 'LOD', 'High-poly']
    const geometryFomats = ['.obj', '.fbx', '.glb', '.usdz', '.stl']
    const materialSets = ['Shaded', 'PBR']
    const materialDpis = ['2K', '4K']
    const progressRef = useRef({});
    const [openMaterialCheck, setOpenMaterialCheck] = useState(false)
    const [genPipeline,] = useRecoilState(rodinGenPipeline);
    const [status, setStatus] = useState({
        isGeoDone: false,
        isMtlDone: false,
        isPacking: false,
        isPackingDone: false,
    });
    const fileFormatRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
    const materialConRef = useRef(null)
    const materialDpisRef = [useRef(null), useRef(null)];
    const materialRef = [useRef(null), useRef(null)];
    const navIndicatorRef = useRef(null)
    // const navIndicatorMaterialRef = useRef(null)
    const navIndicatorMaterialDpisRef = useRef(null)
    const [generatePercentage, setGeneratePercentage] = useState(0)
    const [cards, setCards] = useRecoilState(cardsAtom);
    const userPermission = useRecoilValue(userPermissionAtom);
    const fileFormatDisabled = geometrySettings.geometry === 'Base Model LOD'
    const isView = genPipeline?.taskInfo?.restore?.data?.viewOnly
    const onlyDownload = (status.isGeoDone && status.isMtlDone) || (isView && status.isGeoDone)
    const { t } = useTranslation();
    const [packBtnInfo, setPackBtnInfo] = useState(t('BUTTON_DOWNLOAD'))
    const { refreshInfo } = useRefreshInfo()
    // const logInfo = useRecoilValue(logInfoAtom);
    // const groupInfo = useRecoilValue(groupInfoAtom);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const [publishColorInfo,] = useRecoilState(publishColorInfoAtom)
    const { connect, query, disconnect, onMessage, setReconnectAttempts } = useWebSocket('/scheduler_socket');
    const [sketchClientId, setSketchClientId] = useState('kwhcubZNcio2IGUzSZaiMXpRe3Jl5lXobRCcwP7U')
    const [sketchUrl, setSketchUrl] = useState('http://localhost:3000/authentication.html')
    const [sketchModelUrl, setSketchModelUrl] = useState(false)
    const [sketchUploading, setSketchUploading] = useState(false)
    const [sketchLoading, setSketchLoading] = useState(false)
    const downonlyGeo = useRef(false)
    const [downloadUrls, setDownloadUrls] = useState([])
    const setKeepRodinBoard = useSetRecoilState(setGenerateAtom)
    const [sketchHover, setSketchHover] = useState(false)
    const [sketchProcess, setSketchProcess] = useState(0)
    const chatLang = useRecoilValue(chatLangAtom);
    const currentHost = window.location.host
    const { isAllowedTo } = useContext(PermissionContext);
    const turnstileRef = useRef()
    const token = useRef()
    const taskTimeRef = useRef(null)
    const taskTimeValueRef = useRef(0)
    const queuedIntervalRef = useRef(null);
    const downloadRef = useRef(null);

    const geometryMapping = {
        'Base Model': 'Base',
        'Base Model LOD': 'Lod',
        'High-poly': 'HighPoly',
    };

    const fileFormatMapping = {
        '.glb': 'glb',
        '.usdz': 'usdz',
        '.fbx': 'fbx',
        '.obj': 'obj',
        '.stl': 'stl',
    };

    const resMapping = {
        '2K': 'Basic',
        '4K': 'High'
    }

    useEffect(() => {
        switch (process.env.REACT_APP_ENV || process.env.NODE_ENV) {
            case 'dev':
                setSketchClientId('G2C1z3KNPR217bX3dRDjh6osLMCTHTtOxK3wxSGI')
                setSketchUrl('https://dev.hyperhuman.pages.dev/authentication.html')
                return
            case 'preview':
                setSketchClientId('iUjMmj6BNSYzTfyAk2rszTl5Fmplys1Sjc3K43yc')
                setSketchUrl('https://preview.hyperhuman.pages.dev/authentication.html')
                return
            case 'production':
                switch (currentHost) {
                    case 'hyper3d.ai':
                        setSketchClientId('PXnxsMGZuCisss3sBjdYgy6Bip3xjcY21mH36Aoo')
                        setSketchUrl('https://hyper3d.ai/auth/sketchfab')
                        return
                    case 'hyperhuman.deemos.com':
                        setSketchClientId('jHTlZbJG5hQEBeFEwALyu5u0iXKicaQ5f2JrSwix')
                        setSketchUrl('https://hyperhuman.deemos.com/auth/sketchfab')
                        return
                    default:
                        return;
                }

            default:
                return;
        }
    }, [])

    useEffect(() => {
        return () => {
            if (queuedIntervalRef.current) {
                clearInterval(queuedIntervalRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (genPipeline.geoConfirmed.status) {
            setStatus(prevStatus => ({ ...prevStatus, isGeoDone: true }));
        }
        if (genPipeline.mtlConfirmed.status) {
            setStatus(prevStatus => ({ ...prevStatus, isMtlDone: true }));
        }
    }, [genPipeline]);


    const [size, setSize] = useState();
    const [mode, setMode] = useState(localStorage.getItem('downLoadSizeMode') || 'default');
    const [pos, setPos] = useState(localStorage.getItem('downLoadPos') || 'bottom');
    const { isBusinessOrAbove } = useContext(PermissionContext);

    const changeMode = useCallback((m) => {
        localStorage.setItem('downLoadSizeMode', m);
        setMode(m);
    }, [])

    const changePos = useCallback((m) => {
        // localStorage.setItem('downLoadPos', m);
        setPos(m);
    }, [])

    useEffect(() => {
        if (taskDetail?.settings?.height) {
            setSize(taskDetail?.settings?.height);
        }
    }, [taskDetail?.settings?.height])

    const sendPackRequest = async (index, doubleCheck) => {
        if (taskTimeRef.current) {
            clearInterval(taskTimeRef.current)
        }
        taskTimeValueRef.current = 0
        const defalutMaterial = ['PBR','Shaded']
        setStatus(prevStatus => ({ ...prevStatus, isPacking: true }));
        const uuid = genPipeline.taskInfo.data;
        const serverGeometry = geometryMapping[geometrySettings.geometry] || 'Base';
        const serverFileFormat = fileFormatMapping[geometrySettings.fileFormat] || 'glb';
        // 如果是两个的话要请求两次并且开两个ws？
        const serverMaterial = doubleCheck ? defalutMaterial[index]:materialSettings.material[index];
        const serverRes = resMapping[materialSettings.materialDpis]
        try {
            let res
            const captchaToken = await handleCaptchaVerification(turnstileRef, isAllowedTo('captcha.feature'))
            if (status.isMtlDone) {
                const packParams = {
                    task_uuid: uuid, resolution: serverRes, geometry: serverGeometry, geometry_file_format: serverFileFormat, material: serverMaterial, height: mode === "default" ? null : size, align_ground: pos === "bottom"
                }
                res = await rodinUnlock(packParams, captchaToken)
                trackEvent('Rodin - Pack - MtlDone: Start', packParams, uuid)
            } else {
                if (!downonlyGeo.current) {
                    if (imageWorkflows[selectedImageIndex].status === 'GENERATED') {
                        setOpenMaterialCheck(true)
                        return;
                    } else {
                        const packParams = {
                            task_uuid: uuid,
                            geometry: serverGeometry,
                            geometry_file_format: serverFileFormat,
                            height: mode === "default" ? null : size,
                            align_ground: pos === "bottom"
                        }
                        res = await rodinUnlock(packParams, captchaToken)
                        downonlyGeo.current = false
                        trackEvent('Rodin - Pack - GeoDone: Start', packParams, genPipeline?.taskInfo.data)
                    }
                } else {
                    const packParams = {
                        task_uuid: uuid,
                        geometry: serverGeometry,
                        geometry_file_format: serverFileFormat,
                        height: mode === "default" ? null : size,
                        align_ground: pos === "bottom"
                    }
                    res = await rodinUnlock(packParams, captchaToken)
                    downonlyGeo.current = false
                    trackEvent('Rodin - Pack - GeoDone: Start', packParams, genPipeline?.taskInfo.data)
                }

                // res = await rodinUnlock({
                //     task_uuid: uuid,
                //     geometry: serverGeometry,
                //     geometry_file_format: serverFileFormat,
                //     height: mode === "default" ? null : size,

                // }, captchaToken)
            }
            let subKey = res?.data?.job?.subscription_key
            let jobid = res?.data?.job?.uuids[0]

            if (res?.data?.error || !subKey) {

                tip({
                    type: 'primary',
                    content: t('TIP_PRIMARY_PACK_UNAVA')
                });
                setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
                // setPacked(false)
                return false


            }
            let queued = 0
            let hasStartedQueued = false
            let hasStartedGenerating = false
            setKeepRodinBoard(true)
            connect(subKey, jobid)
            query(jobid)
            queuedIntervalRef.current = setInterval(() => {
                query(jobid)
            }, 10000)
            taskTimeRef.current = setInterval(()=>{
                taskTimeValueRef.current = taskTimeValueRef.current + 1
            },1000)
            setReconnectAttempts(0)
            return new Promise((resolve) => {
                onMessage('message', async (data, res) => {
                    if (res?.jobStatus === 'Queued' && index === 0) {
                        setIsQueued(true)
                        ReactGA.event(
                            {
                                category: 'hyper3d',
                                action: 'queued_pack',
                                label: 'pressure_tracking'
                            }
                        )
                        if (!hasStartedQueued) {
                            setGeneratePercentage(0)
                            const progressBarDelay = 50;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, 10)
                            queued = res?.jobWaitingLength ? res.jobWaitingLength:0 + 1
                            hasStartedQueued = true
                        } else {
                            const progressBarDelay = 50;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, -((res?.jobWaitingLength ? res.jobWaitingLength:0) * 10 - Number(queued) * 10))
                        }

                    }
                    if (res?.jobStatus === 'BackPressure' && index === 0) {
                        setGeneratePercentage(0)
                        setIsQueued(true)
                    }
                    if (res?.jobStatus === 'Running' && !hasStartedGenerating && index === 0) {
                        if (queued === 0) {
                            setGeneratePercentage(0)
                        } else {
                            doneFakeProgressBar(setGeneratePercentage, queued * 10)
                        }
                        setIsQueued(false)
                        hasStartedGenerating = true

                        if (doubleCheck) {
                            const progressBarDelay = 30 + queued;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, 90)
                        } else {
                            const progressBarDelay = 10 + queued;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, 90)
                        }

                    }
                    // Fetch preview images
                    if (res?.jobStatus === 'Canceled') {
                        trackEvent('Rodin - Pack: Canceled', false, genPipeline?.taskInfo.data)
                        ReactGA.event(
                            {
                                category: 'hyper3d',
                                action: 'failed_pack',
                                label: 'pressure_tracking'
                            }
                        )
                        disconnect()
                        if (queuedIntervalRef.current) {
                            clearInterval(queuedIntervalRef.current)
                        }
                        if (taskTimeRef.current) {
                            clearInterval(taskTimeRef.current)
                        }
                        taskTimeValueRef.current = 0
                        setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
                        tip({
                            type: 'error',
                            content: t('TIP_ERR_KINDLY_ANEW')
                        })
                        resolve(false)
                        return
                    }
                    if (res?.jobStatus === 'Succeeded') {
                        disconnect()
                        if (queuedIntervalRef.current) {
                            clearInterval(queuedIntervalRef.current)
                        }
                        if (!hasStartedGenerating && doubleCheck && index === 0) {
                            if (queued === 0) {
                                setGeneratePercentage(0)
                            } else {
                                doneFakeProgressBar(setGeneratePercentage, queued * 10)
                            }
                        }
                        trackEvent('Rodin - Pack: Succeeded', { credits:0, executionTime:taskTimeValueRef.current }, genPipeline?.taskInfo.data)
                        if (taskTimeRef.current) {
                            clearInterval(taskTimeRef.current)
                        }
                        setIsQueued(false)
                        const uuid = genPipeline.taskInfo.data;
                        const urls = (await getTaskDownload(uuid))?.list;
                        if (!urls) {
                            console.error("Resource download error.");
                            return;
                        }

                        const err = urls.find((url) => url.error);
                        if (err) {
                            console.error(err.error);
                            return;
                        }
                        setTimeout(async () => {
                            if (!(doubleCheck && index === 0)) {
                                setKeepRodinBoard(false)
                                doneFakeProgressBar(setGeneratePercentage, 90)
                                setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
                            }
                            resolve(urls);
                        }, 1500);
                    }
                }, () => {
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'failed_pack',
                            label: 'pressure_tracking'
                        }
                    )
                    disconnect()
                    if (queuedIntervalRef.current) {
                        clearInterval(queuedIntervalRef.current)
                    }
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                    setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
                    tip({
                        type: 'error',
                        content: t('TIP_ERR_KINDLY_ANEW')
                    })
                    resolve(false)
                    return
                });
            });
        } catch (e) {
            trackEvent('Rodin - Pack: Failed', false, genPipeline?.taskInfo.data)
            Sentry.captureException(e)
            tip({
                type: 'error',
                presetText: 'ERROR',
                content: e
            });
            setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
            return false
        }
    }

    useEffect(() => {
        if (!status.isPacking) {
            setGeneratePercentage(0)
        }
    }, [status.isPacking])

    useEffect(() => {
        if (navIndicatorRef.current) {
            const index = geometryFomats.findIndex((item) => item === geometrySettings.fileFormat)
            const indicator = navIndicatorRef.current
            const width = fileFormatRef[index].current.offsetWidth
            indicator.style.width = `${width}px`;
            indicator.style.left = `${fileFormatRef[index].current.offsetLeft}px`;
        }
    }, [navIndicatorRef, geometrySettings])

    // useEffect(() => {
    //     if (navIndicatorMaterialRef.current) {
    //         const index = materialSets.findIndex((item) => item === materialSettings.material)
    //         const indicator = navIndicatorMaterialRef.current
    //         const width = materialRef[index].current.offsetWidth
    //         indicator.style.width = `${width}px`;
    //         indicator.style.left = `${materialRef[index].current.offsetLeft}px`;
    //     }
    // }, [navIndicatorMaterialRef, materialSettings])

    useEffect(() => {
        if (navIndicatorMaterialDpisRef.current) {
            const index = materialDpis.findIndex((item) => item === materialSettings.materialDpis)
            const indicator = navIndicatorMaterialDpisRef.current
            const width = materialDpisRef[index].current.offsetWidth
            indicator.style.width = `${width}px`;
            indicator.style.left = `${materialDpisRef[index].current.offsetLeft}px`;
        }
    }, [navIndicatorMaterialDpisRef, materialSettings])

    const handlerChooseGeometry = (key, value) => {
        if (taskDetail.settings["mesh_export_type"] === 'Raw' && value === 'High-poly') {
            return;
        }
        if (key === 'fileFormat') {
            if (fileFormatDisabled) {
                return
            }
            setGeometrySettings(pre => {
                const p = { ...pre }
                p[key] = value
                return p
            })
        } else {
            if (value === 'High-poly' && !isBusinessOrAbove()) {
                setHighPolyTipBox(true)
                setTimeout(() => {
                    setHighPolyTipBox(false)
                }, 5000);
                return
            }
            setGeometrySettings(prev => {
                if (value === 'High-poly') {
                    return { ...prev, geometry: 'High-poly' };
                } else if (value === 'LOD') {
                    let newGeometry
                    let newFileFormat = prev.fileFormat
                    if (prev.geometry.includes('LOD')) {
                        newGeometry = 'Base Model'
                    } else {
                        newGeometry = 'Base Model LOD'
                        newFileFormat = '.fbx'
                    }
                    return { fileFormat: newFileFormat, geometry: newGeometry };
                } else if (value === 'Base Model') {
                    const newGeometry = prev.geometry === 'High-poly' ? 'Base Model' : prev.geometry
                    return { ...prev, geometry: newGeometry };
                }
                return prev;
            });
        }
    }

    const handlerChooseMaterial = (key, value) => {
        if (['2K', '4K'].includes(value)) {
            if (value === '4K' && !isBusinessOrAbove()) {
                setMtlTipBox(true);
                setTimeout(() => {
                    setMtlTipBox(false);
                }, 5000);
                return;
            }
            setMaterialSettings(pre => {
                const p = { ...pre }
                p[key] = value
                return p
            })
        } else {
            setMaterialSettings(prevState => {
                let updatedMaterial = [...prevState.material];
                const index = updatedMaterial.indexOf(value);

                if (index === -1) {
                    // 如果数组中不存在该项，则添加
                    updatedMaterial.push(value);
                } else {
                    // 如果数组中存在该项，则移除
                    if (updatedMaterial.length > 1) {
                        updatedMaterial.splice(index, 1);
                    }
                }

                return {
                    ...prevState,
                    material: updatedMaterial
                };
            });
        }
    };

    useEffect(() => {
        if (downloadRef.current) {
            if (sessionStorage.getItem('task_uuid') === taskDetail?.task_uuid && sessionStorage.getItem('High-Poly-Driver') === 'true') {
                setTimeout(() => {
                    driverHighPoly()
                }, 1500);
            }
        }
    }, [downloadRef.current])

    useEffect(() => {
        return () => {
            if (sessionStorage.getItem('task_uuid') === taskDetail?.task_uuid && sessionStorage.getItem('High-Poly-Driver') === 'true') {
                sessionStorage.removeItem('task_uuid')
                sessionStorage.removeItem('High-Poly-Driver')
            }
        }
    }, [])

    const driverGuide = (balance) => {
        setModalObj({ ...modalObj, state: false });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setOpenPaymentInfo({
            ...openPaymentInfo,
            state: true,
            group: taskDetail?.group,
            balance: balance,
            step: 1
        })

        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
        });
        const target = taskDetail?.group ? "#rechargeGroup #rechargePopup" : "#rechargeSelf #rechargePopup"
        driverObj.highlight({
            element: target,
            popover: {
                title: t('DRIVEROBJ_BALANCE_TITLE'),
                description: t('DRIVEROBJ_BALANCE_DESC'),
                popoverClass: "rechargedriver"
            }
        });
        const dom = document.querySelector(target)
        if (dom) {
            dom.addEventListener("click", () => {
                driverObj.destroy();
            });
        }
    }

    const driverHighPoly = () => {
        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
        });
        driverObj.highlight({
            element: '#High-poly',
            popover: {
                description: t('DRIVEROBJ_HIGHPOLY_DESC'),
                popoverClass: "rechargedriver"
            }
        });
        if (document.querySelector('#High-poly')) {
            document.querySelector('#High-poly').addEventListener("click", () => {
                driverObj.destroy();
                sessionStorage.removeItem('task_uuid')
                sessionStorage.removeItem('High-Poly-Driver')
            });
        }
    }

    const setShowLogin = useSetRecoilState(showLoginAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const handleDownload = async () => {
        const isViewOnly = genPipeline?.taskInfo?.restore?.data?.viewOnly;

        if (!logInfo) {
          setShowLogin(true)
          return
        }

        if (isAllowedTo('billing.feature')) {
            const isGroupLowBalance = taskDetail?.group && (balance.groupBalance / 10) < 1;
            const isPersonalLowBalance = !taskDetail?.group && (balance.selfBalance / 10 + subscriptionsInfo.wallet_balance) < 1;
            if (isViewOnly && (isGroupLowBalance || isPersonalLowBalance)) {
                driverGuide();
                return;
            }
        }


        // const packResult = await sendPackRequest();
        let packResult = false
        if (genPipeline.mtlConfirmed?.status) {
            if (materialSettings.material.length === 1) {
                const packResult1 = await sendPackRequest(0, false);
                packResult = [packResult1]
            } else if (materialSettings.material.length === 2) {
                const packResult1 = await sendPackRequest(0, true);
                const packResult2 = await sendPackRequest(1, true);
                packResult = [packResult1, packResult2]
            }
        } else {
            const packResult1 = await sendPackRequest(0, false);
            packResult = [packResult1]
        }

        setStatus(prevStatus => ({ ...prevStatus, isPacking: true }));
        try {
            if (!packResult) {
                console.error("Resource download error.");
                return;
            }

            await handleDownloadZip(packResult)

            // Find and directly download any .glb files
            // const glbFiles = downloadUrls.filter(url => url.name.endsWith('.glb'));
            // if (glbFiles.length > 0) {
            //     for (const file of glbFiles) {
            //         const { url, name } = file;
            //         const response = await fetch(url);
            //         const blob = await response.blob();
            //         const a = document.createElement('a');
            //         const blobUrl = URL.createObjectURL(blob);
            //         a.href = blobUrl;
            //         a.download = name;
            //         document.body.appendChild(a);
            //         a.click();
            //         document.body.removeChild(a);
            //         URL.revokeObjectURL(blobUrl);
            //     }
            //     return;
            // } else {
            //     console.error("No .glb files found.");
            //     await handleDownloadZip(packResult)
            //     // Optionally, handle the case where no .glb files are found
            // }

        } catch (e) {
            console.error(e);
        } finally {
            setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
        }
    };

    const handleDownloadZip = async (packResult) => {
        const isViewOnly = genPipeline?.taskInfo?.restore?.data?.viewOnly

        if (isAllowedTo('billing.feature')) {
            const isGroupLowBalance = taskDetail?.group && (balance.groupBalance / 10) < 1
            const isPersonalLowBalance = !taskDetail?.group && (balance.selfBalance / 10 + subscriptionsInfo.wallet_balance) < 1
            if (isViewOnly && (isGroupLowBalance || isPersonalLowBalance)) {
                driverGuide()
                return
            }
        }

        // await sendPackRequest()
        setStatus(prevStatus => ({ ...prevStatus, isPacking: true }));
        try {
            const urls = packResult

            const totalFiles = Math.max(urls.length, 1);

            // if (totalFiles === 1 && urls[0].name.endsWith('.glb')) {
            //     // Directly download the single .glb file
            //     const { url, name } = urls[0];
            //     const response = await fetch(url);
            //     const blob = await response.blob();
            //     const a = document.createElement('a');
            //     const blobUrl = URL.createObjectURL(blob);
            //     a.href = blobUrl;
            //     a.download = name;
            //     document.body.appendChild(a);
            //     a.click();
            //     document.body.removeChild(a);
            //     URL.revokeObjectURL(blobUrl);
            //     return;
            // }
            if (urls.length === 1) {
                const glbFiles = urls[0].filter(url => url.name.endsWith('.glb'));
                if (glbFiles.length > 0) {
                    for (const file of glbFiles) {
                        const { url, name } = file;
                        const response = await fetch(url);
                        const blob = await response.blob();
                        const a = document.createElement('a');
                        const blobUrl = URL.createObjectURL(blob);
                        a.href = blobUrl;
                        a.download = name;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(blobUrl);
                    }
                    return;
                } else {
                    const responses = await Promise.all(
                        urls[0].map(async (urlObj) => {
                            const { url, name } = urlObj;
                            if (!url || url === 'FILE_NOT_FOUND') {
                                tip({
                                    type: 'error',
                                    presetText: 'ERROR',
                                    content: `${name} not found`,
                                });
                                return null;
                            }
                            const blob = await fetchWithRetries(url, (progress) => {
                                progress = Math.min(progress, 1);
                                progressRef.current[`${name} `] = progress;
                                // Comment for future use
                                // eslint-disable-next-line no-unused-vars
                                const totalProgress = parseFloat(
                                    Object.values(progressRef.current)
                                        .reduce((sum, p) => sum + p / totalFiles, 0)
                                        .toFixed(2),
                                );

                            });
                            return { blob, name };
                        }),

                    );
                    for (const responseObj of responses) {
                        if (!responseObj) continue;
                        const { blob, name } = responseObj;
                        zip.current.file(name, blob);
                    }
                }
            } else if (urls.length === 2) {
                const glbFiles1 = urls[0].filter(url => url.name.endsWith('.glb'));
                const glbFiles2 = urls[1].filter(url => url.name.endsWith('.glb'));
                if (glbFiles1.length > 0 && glbFiles2.length > 0) {
                    for (const file of glbFiles1) {
                        const { url, name } = file;
                        const response = await fetch(url);
                        const blob = await response.blob();
                        zip.current.folder("Pbr").file(name, blob);
                    }
                    for (const file of glbFiles2) {
                        const { url, name } = file;
                        const response = await fetch(url);
                        const blob = await response.blob();
                        zip.current.folder("Shaded").file(name, blob);
                    }
                } else {
                    const responses1 = await Promise.all(
                        urls[0].map(async (urlObj) => {
                            const { url, name } = urlObj;
                            if (!url || url === 'FILE_NOT_FOUND') {
                                tip({
                                    type: 'error',
                                    presetText: 'ERROR',
                                    content: `${name} not found`,
                                });
                                return null;
                            }
                            const blob = await fetchWithRetries(url, (progress) => {
                                progress = Math.min(progress, 1);
                                progressRef.current[`${name} `] = progress;
                                // Comment for future use
                                // eslint-disable-next-line no-unused-vars
                                const totalProgress = parseFloat(
                                    Object.values(progressRef.current)
                                        .reduce((sum, p) => sum + p / totalFiles, 0)
                                        .toFixed(2),
                                );

                            });
                            return { blob, name };
                        }),
                    );
                    for (const responseObj of responses1) {
                        if (!responseObj) continue;
                        const { blob, name } = responseObj;
                        zip.current.folder("Pbr").file(name, blob);
                    }
                }
                const responses2 = await Promise.all(
                    urls[1].map(async (urlObj) => {
                        const { url, name } = urlObj;
                        if (!url || url === 'FILE_NOT_FOUND') {
                            tip({
                                type: 'error',
                                presetText: 'ERROR',
                                content: `${name} not found`,
                            });
                            return null;
                        }
                        const blob = await fetchWithRetries(url, (progress) => {
                            progress = Math.min(progress, 1);
                            progressRef.current[`${name} `] = progress;
                            // Comment for future use
                            // eslint-disable-next-line no-unused-vars
                            const totalProgress = parseFloat(
                                Object.values(progressRef.current)
                                    .reduce((sum, p) => sum + p / totalFiles, 0)
                                    .toFixed(2),
                            );

                        });
                        return { blob, name };
                    }),

                );
                for (const responseObj of responses2) {
                    if (!responseObj) continue;
                    const { blob, name } = responseObj;
                    zip.current.folder("Shaded").file(name, blob);
                }

            }



            // if (onlyDownload && fileFormatMapping[geometrySettings.fileFormat] === 'obj') {
            //     const target = materialSettings.material === 'Shaded' ? '/assets/obj/shaded.mtl' : '/assets/obj/pbr.mtl'
            //     const response = await fetch(target)
            //     if (response.ok) {
            //         const blob = await response.blob()
            //         zip.current.file('base.mtl', blob);
            //     } else {
            //         console.error('Failed to fetch the .mtl file: ');
            //     }
            // }

            progressRef.current = {};
            const uuid = genPipeline.taskInfo.data;
            doneFakeProgressBar(setGeneratePercentage, 100)
            trackEvent('Rodin - Download: Success', genPipeline?.taskInfo.data)
            if (zip.current && zip.current.file && zip.current.generateAsync) {
                try {
                    const content = await zip.current.generateAsync({ type: 'blob' });
                    const a = document.createElement('a');
                    const url = URL.createObjectURL(content);
                    a.href = url;
                    a.download = uuid + '.zip';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    if (!taskDetail.is_like) {
                        handleLikeClick(uuid)
                    }
                    setTaskDetail({
                        ...taskDetail,
                        is_like: true,
                        user_state: "DoneBasic"
                    })
                    setPackBtnInfo(t('BUTTON_DOWNLOAD'))
                    if (genPipeline?.taskInfo?.restore?.data?.viewOnly) {
                        refreshInfo(taskDetail?.group ? 'group' : 'user')
                    }
                } catch (e) {
                    zip.current = new JSZip();
                    console.error('Error downloading zip:', e);
                    tip({
                        type: 'error',
                        presetText: 'ERROR',
                        content: t('TIP_ERR_PACK_DOWN_FILE'),
                    });
                }
            } else {
                zip.current = new JSZip();
                console.error('zip.current is not set up correctly.');
            }

        } catch (e) {
            console.error(e);
        } finally {
            setStatus(prevStatus => ({ ...prevStatus, isPacking: false }));
            zip.current = new JSZip();
        }
    };

    async function fetchWithRetries(url, onProgress, retries = 3) {
        for (let i = 0; i < retries; i++) {
            try {
                return await fetchWithProgress(url, onProgress);
            } catch (error) {
                if (i === retries - 1) {
                    throw error;
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }
    }

    async function fetchWithProgress(url, onProgress) {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status} `);
        }

        const reader = response.body.getReader();
        const contentLength = +response.headers.get('Content-Length');
        let receivedLength = 0;

        const chunks = [];
        // eslint-disable-next-line no-constant-condition
        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            receivedLength += value.length;
            onProgress && onProgress(receivedLength / contentLength);
        }

        const chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (const chunk of chunks) {
            chunksAll.set(chunk, position);
            position += chunk.length;
        }
        return new Blob([chunksAll]);
    }

    const handlerStop = (e) => {
        e.stopPropagation()
    }

    const handleLikeClick = async (task_uuid) => {
        try {
            const newCards = JSON.parse(JSON.stringify(cards));
            const index = cards.findIndex((item) => item.task_uuid === task_uuid);
            if (index !== -1) {
                newCards[index].is_like = true;
                newCards[index].num_like += 1;
                setCards(newCards);
            }
            likeCard({ task_uuid, operation: 'Like' })
        } catch (e) {
            Sentry.captureException(e);
            console.error(e);
        }
    };

    const handleShowCredits = () => {
        const data = genPipeline?.taskInfo?.restore?.data
        if (data?.viewOnly && taskDetail?.user_state === "DonePreview") {
            setPackBtnInfo('1 Credit')
        }
    }

    const handleCloseCredits = () => {
        setPackBtnInfo(t('BUTTON_DOWNLOAD'))
    }

    const handleUpload = async () => {
        try {
            setSketchProcess(0)
            zip.current = new JSZip();
            const config = {
                hostname: 'sketchfab.com',
                client_id: sketchClientId,
                redirect_uri: sketchUrl,
            };
            const formData = new FormData();
            let Done = false
            const client = new SketchfabOAuth2(config)
            const uuid = genPipeline.taskInfo.data;
            const serverGeometry = geometryMapping[geometrySettings.geometry] || 'Base';
            const serverMaterial = materialSettings.material;
            const serverRes = resMapping[materialSettings.materialDpis]

            const captchaToken = await handleCaptchaVerification(turnstileRef, isAllowedTo('captcha.feature'))
            let res
            if (status.isMtlDone) {
                res = await rodinUnlock({
                    task_uuid: uuid, resolution: serverRes, geometry: serverGeometry, geometry_file_format: status.isMtlDone ? 'obj' : 'usdz', material: serverMaterial.length > 1 ? 'PBR' : serverMaterial,
                }, captchaToken)
            } else {
                res = await rodinUnlock({
                    task_uuid: uuid,
                    geometry: serverGeometry,
                    geometry_file_format: status.isMtlDone ? 'obj' : 'usdz',

                }, captchaToken)
            }
            // const res = await rodinUnlock({ task_uuid: uuid, resolution: serverRes, geometry: serverGeometry, geometry_file_format: status.isMtlDone ? 'obj' : 'usdz', material: serverMaterial }, captchaToken)
            let subKey = res?.data?.job?.subscription_key
            if (res?.data?.error || !subKey) {
                tip({
                    type: 'primary',
                    content: t('TIP_PRIMARY_PACK_UNAVA')
                });
                // setPacked(false)
                return false
            }
            connect(subKey);
            setReconnectAttempts(0)
            onMessage('message', async (data, res) => {
                // Fetch preview images
                if (res?.jobStatus === 'Succeeded') {
                    setTimeout(async () => {
                        disconnect()
                        const urls = (await getTaskDownload(uuid))?.list
                        if (!urls) {
                            console.error("Resource download error.")
                            return
                        }

                        const err = urls.find((url) => url.error);
                        if (err) {
                            console.error(err.error)
                            return
                        }
                        const totalFiles = Math.max(urls.length, 1);
                        const responses = await Promise.all(
                            urls.map(async (urlObj) => {
                                const { url, name } = urlObj;
                                if (!url || url === 'FILE_NOT_FOUND') {
                                    tip({
                                        type: 'error',
                                        presetText: 'ERROR',
                                        content: `${name} not found`,
                                    });
                                    return null;
                                }
                                const blob = await fetchWithRetries(url, (progress) => {
                                    progress = Math.min(progress, 1);
                                    progressRef.current[`${name} `] = progress;
                                    // Leave it here for future use
                                    // eslint-disable-next-line no-unused-vars
                                    const totalProgress = parseFloat(
                                        Object.values(progressRef.current)
                                            .reduce((sum, p) => sum + p / totalFiles, 0)
                                            .toFixed(2),
                                    );
                                });
                                return { blob, name };
                            }),
                        );
                        for (const responseObj of responses) {
                            if (!responseObj) continue;
                            const { blob, name } = responseObj;
                            if (name === 'shaded.png') {
                                zip.current.file('texture-emission.png', blob);
                            } else {
                                zip.current.file(name, blob);
                            }
                        }
                        if (status.isMtlDone && fileFormatMapping[geometrySettings.fileFormat] === 'obj') {
                            const target = materialSettings.material === 'Shaded' ? '/assets/obj/shaded.mtl' : '/assets/obj/pbr.mtl'
                            const response = await fetch(target)
                            if (response.ok) {
                                const blob = await response.blob()
                                zip.current.file('base.mtl', blob);
                            } else {
                                console.error('Failed to fetch the .mtl file: ');
                            }
                        }
                        const content = await zip.current.generateAsync({ type: 'blob' });
                        if (zip.current && zip.current.file && zip.current.generateAsync) {
                            const hex = '#'
                            let red, green, blue = ''
                            if (publishColorInfo && publishColorInfo !== undefined) {
                                if (Number(publishColorInfo.r) === 0) {
                                    red = '00'
                                } else {
                                    red = Number(publishColorInfo.r).toString(16)
                                }
                                if (Number(publishColorInfo.g) === 0) {
                                    green = '00'
                                } else {
                                    green = Number(publishColorInfo.g).toString(16)
                                }
                                if (Number(publishColorInfo.b) === 0) {
                                    blue = '00'
                                } else {
                                    blue = Number(publishColorInfo.b).toString(16)
                                }
                            } else {
                                red = 'ff'
                                green = 'ff'
                                blue = 'ff'
                            }
                            let background = ''
                            if (serverMaterial === 'PBR') {
                                background = {
                                    background: {
                                        color: hex + red + green + blue,
                                    }
                                }
                            } else {
                                background = {
                                    background: {
                                        color: hex + red + green + blue,
                                    },
                                    shading: 'shadeless'
                                }
                            }
                            let name = ''
                            if (taskDetail.prompt.length > 48) {
                                name = taskDetail.prompt.substring(0, 47)
                            } else {
                                name = taskDetail.prompt
                            }
                            if (name.split('.').length > 1) {
                                name = name.split('.')[0]
                            }
                            if (name.split(',').length > 1) {
                                name = name.split(',')[0]
                            }
                            formData.append('options', JSON.stringify(background))
                            formData.append('modelFile', content, 'model.zip')
                            formData.append('filename', 'model.zip')
                            formData.append('name', name)
                            formData.append('tags', `"[Rodin]" "Gen-1" "CreatedWithAI" ${serverMaterial === 'PBR' ? "Pbr" : 'Shaded'}`)
                            formData.append('description', `This model is generated by the state-of-the-art 3D GenAI tool, Rodin Gen-1.However, its ideas and creativity originate from the human author.` + '\n\n' + `Create your own model from images:` + '\n\n' + `[https://hyperhuman.deemos.com](https://hyperhuman.deemos.com)` + '\n\n' + `[https://hyper3d.ai](https://hyper3d.ai)`)
                            Done = true
                            // if(model && model.data){
                            //     const intervate=setInterval(async ()=>{
                            //         const state=await getSketchfabState(grant.access_token,model.data.uid)
                            //         console.log('state',state.data)
                            //         if(state && state.data && state.data.status && state.data.status.processing==='SUCCEEDED'){
                            //             clearInterval(intervate)
                            //             setSketchModelUrl(`https://sketchfab.com/3d-models/${model.data.uid}`)
                            //         }
                            //     },2000)
                            // }
                        }
                    }, 1500);
                }
                if (res?.jobStatus === 'Failed') {
                    tip({
                        type: 'error',
                        content: t('TIP_ERR_KINDLY_ANEW')
                    })
                    disconnect()
                    return
                }
            });
            client.connect().then(async function onSuccess(grant) {
                if (grant && grant.access_token) {
                    setSketchLoading(true)
                    setKeepRodinBoard(true)
                    let process = 0
                    setSketchUploading(true)
                    const intervate = setInterval(async () => {
                        if (process < 50) {
                            process += 5
                            setSketchProcess(old => old + 5)
                        }
                        if (Done) {
                            clearInterval(intervate)
                            const model = await uploadToSketchfab(grant.access_token, formData)
                            if (model.data?.error) {
                                tip({
                                    type: 'error',
                                    content: model.data?.error
                                })
                            } else {
                                const inter = setInterval(() => {
                                    if (process < 70) {
                                        process += 5
                                        setSketchProcess(old => old + 5)
                                    }
                                    if (model && model.data) {
                                        clearInterval(inter)
                                        const intervates = setInterval(async () => {
                                            if (process < 95) {
                                                process += 5
                                                setSketchProcess(old => old + 5)
                                            }
                                            const state = await getSketchfabState(grant.access_token, model.data.uid)
                                            if (state && state.data && state.data.status && state.data.status.processing === 'SUCCEEDED') {
                                                clearInterval(intervates)
                                                process = 100
                                                setSketchProcess(100)
                                                setKeepRodinBoard(false)
                                                setSketchModelUrl(`https://sketchfab.com/3d-models/${model.data.uid}`)
                                            }
                                        }, 1000)
                                    }
                                }, 1000)
                            }


                        }
                    }, 1000)
                }
            }).catch(function onError(error) {
                console.error(error);
            });
        } catch (error) {
            console.error(error);
        }

        // await rodinUnlock({ task_uuid: uuid, resolution: serverRes, geometry: serverGeometry, geometry_file_format: status.isMtlDone?'obj':'usdz', material: serverMaterial })



    }

    const sketchClickState = (e) => {
        if (e?.target?.parentNode?.id !== 'publishBoard') {
            setSketchModelUrl(false)
            setSketchUploading(false)
            setSketchLoading(false)
            document.removeEventListener('click', sketchClickState)
        }
    }

    useEffect(() => {
        if (sketchModelUrl) {
            document.addEventListener('click', sketchClickState)
        } else {
            setSketchModelUrl(false)
            setSketchUploading(false)
            setSketchLoading(false)
            document.removeEventListener('click', sketchClickState)
        }
    }, [sketchModelUrl])


    useEffect(() => {
        if (sketchHover) {
            setTimeout(() => {
                setSketchHover(false)
            }, [1000])
        }
    }, [sketchHover])


    return (
        <div id='iframe' ref={ref} className={`${style.packWrapper} ${onlyDownload ? style.onlyDownload : ""} `}>
            <div onClick={(e) => {
                if (materialConRef.current.contains(e.target)) {
                    return;
                } else {
                    setOpenMaterialCheck(false)
                }
            }} className={`fixed  w-[100%] h-[100%] z-[99999] top-0 left-0 flex justify-center items-center ${openMaterialCheck ? ' opacity-100 visible' : 'animation-face-check'}`}>
                <div ref={materialConRef} className={`p-[24px] max-w-[382px] gap-[12px] font-[Arial] flex flex-col [transition:all_0.3s_cubic-bezier(0.23,1,0.32,1)]  ${openMaterialCheck ? ' opacity-100 visible scale-100' : ' opacity-0 invisible scale-0'} bg-[rgba(255,255,255,0.8)] backdrop-blur-[50px] rounded-2xl [box-shadow:0px_0px_12px_0px_rgba(74,0,224,0.15)]`}>
                    <span className='text-[20px] font-bold text-[rgba(45,45,45,1)]'>{t('RODIN_CONFIRM_MATERIAL')}</span>
                    <span className='text-[14px] text-[rgba(102,102,102,1)] text-left'>{t('RODIN_CONFIRM_MATERIAL_TITLE')}</span>
                    <div className='w-full flex flex-row justify-between'>
                        <button onClick={() => {
                            setOpenMaterialCheck(false)
                            downonlyGeo.current = true
                            handleDownload()
                        }} className='w-[48%] py-[10px] [transition:all_0.3s_ease] bg-[rgba(176,176,176,0.5)] hover:bg-[rgba(176,176,176,0.3)] rounded-[35px] text-[rgba(48,48,48,1)]'>{t('RODIN_CONFIRM_MATERIAL_NO')}</button>
                        <button onClick={() => { setCheckImgConfirm(true); setOpenMaterialCheck(false) }} className='w-[48%] py-[10px] [transition:all_0.3s_ease] bg-[linear-gradient(180deg,#6D49FF_0%,#A347FF_100%)] hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)] rounded-[35px] text-white'>{t('THREEWRAPPER_BUTTON_CONFIRM')}</button>
                    </div>
                </div>
            </div>
            <div className={style.packHeader}>
                {t('RODIN_GENERTAE_BOARD_PACK_TITLE')}
            </div>
            <div className={`${style.packBody} `}>
                <div className={style.packGeometry}>
                    {!status.isGeoDone && <div className={style.mtlmask}></div>}
                    <div className={style.subTitle}>
                        {t('RODIN_GENERTAE_BOARD_PACK_SUB_TITLE_1')}
                        {!status.isGeoDone ? <LockTip status={status.isGeoDone} message={t('UNLOCK_GEO_TIP')} /> :
                            <Switch
                                size={size}
                                setSize={setSize}
                                mode={mode}
                                setMode={changeMode}
                                pos={pos}
                                setPos={changePos}
                                packing={status.isPacking} />
                        }
                    </div>
                    <div className={style.geometry}>
                        <div className={`${style.geometryset} ${status.isGeoDone ? '' : style.default} `}>
                            {taskDetail.settings["mesh_export_type"] === 'Raw' && <div className='absolute top-[15%] right-[2%] h-[70%] w-[30%] rounded-[4px] bg-[rgba(104,104,104,0.1)]'></div>}
                            {geometrySets.map((item, index) => {
                                const defalutTime = new Date(globalTimeStamp).getTime()
                                const cardTime = new Date(taskDetail.time).getTime()
                                if (defalutTime - cardTime > 0 && item === 'High-poly') {
                                    return;
                                }
                                return (
                                    <div className={`${style.modelQualityBox} ${geometrySettings.geometry.includes(item) ? style.checked : ''} 
                                    ${taskDetail.settings["mesh_export_type"] === 'Raw' && item === 'High-poly' ? `${style.rawcheck}` : ''}`} key={index} id={item}
                                        onClick={handlerChooseGeometry.bind(null, 'geometry', item)}>
                                        <div
                                            className={`${style.checkBox} ${geometrySettings.geometry.includes(item) ? style.checked : ''} `} />
                                        {item}
                                        {item === 'High-poly' && <ShakeTips setShow={setHighPolyTipBox} show={highPolyTipBox} />}
                                    </div>
                                )
                            })}
                        </div>
                        <div className={`${style.format} ${style.formatWrapper} ${fileFormatDisabled ? style.fileFormatDisabled : ""} ${status.isGeoDone ? '' : style.default} `}>
                            {geometryFomats.map((item, index) => {
                                return (
                                    <div
                                        ref={fileFormatRef[index]}
                                        key={index}
                                        onClick={handlerChooseGeometry.bind(null, 'fileFormat', item)}
                                        className={`${style.modelFomatBox} ${geometrySettings.fileFormat === item ? style.checked : ''} `}>
                                        {item}
                                    </div>
                                )
                            })}
                            <div className={style.formatWrapperSlider} ref={navIndicatorRef}></div>
                        </div>
                    </div>
                </div>
                <div id='downloadTab' className={`${style.packMaterial}`}>
                    {!status.isMtlDone && <div className={style.mtlmask} ></div>}
                    <div className={style.subTitle}>
                        {t('RODIN_GENERTAE_BOARD_PACK_SUB_TITLE_2')}
                        {!status.isMtlDone && <LockTip status={status.isMtlDone} message={t('UNLOCK_MAT_TIP')} />}
                    </div>
                    <div className={style.material}>
                        <div className={`${style.format} ${status.isMtlDone ? '' : style.default} `}>
                            {materialSets.map((item, index) => {
                                return (
                                    <div

                                        ref={materialRef[index]}
                                        key={index}
                                        onClick={handlerChooseMaterial.bind(null, 'material', item)}
                                        className={`${style.modelFomatBox} ${materialSettings.material.includes(item) ? style.checked : ''} flex items-center gap-2`}>
                                        <div className={`${style.checkBox} ${materialSettings.material.includes(item) && genPipeline.mtlConfirmed?.status ? style.checked : ''} `} />
                                        {item}</div>
                                )
                            })}
                            {/* <div className={style.formatWrapperSlider} ref={navIndicatorMaterialRef}></div> */}
                        </div>
                        <div className={`${style.format} ${status.isMtlDone ? '' : style.default} `}>
                            {materialDpis.map((item, index) => {
                                return (
                                    <div
                                        style={{ position: 'relative' }}
                                        ref={materialDpisRef[index]}
                                        key={index}
                                        onClick={handlerChooseMaterial.bind(null, 'materialDpis', item)}
                                        className={`${style.modelFomatBox} ${materialSettings.materialDpis === item ? style.checked : ''} `}>
                                        {item}
                                        {item === '4K' && <ShakeTips setShow={setMtlTipBox} show={mtlTipBox} />}

                                    </div>
                                )
                            })}
                            <div className={style.formatWrapperSlider} ref={navIndicatorMaterialDpisRef}></div>
                        </div>
                    </div>
                </div>
            </div>
            {(status.isGeoDone || status.isMtlDone) && (
                <div className={style.packButton}>
                    {
                        status.isPacking ? <WaitingProgress percentage={generatePercentage} queue={isQueued} /> : (
                            <div className='w-full flex gap-[var(--smGap)] relative' >
                                <Restricted to="sketchfab.card.rodin.view">
                                    {!genPipeline?.taskInfo?.restore?.data?.viewOnly && <div className={`flex-1 bg-[rgba(74,_0,_224,_0.05)] rounded-[60px] border border-solid border-transparent font-bold [font-size:var(--lgFs)] text-[#305FDD] leading-[var(--lgFs)] not-italic normal-case p-[var(--miniGeoBtn)] [transition:all_0.5s_ease] relative flex flex-row justify-center items-center
                                     ${sketchLoading ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-white hover:border-transparent hover:[box-shadow:0_0_6pt_rgba(75,_0,_224,15%)]'}`} onClick={sketchLoading ? () => { } : handleUpload}>
                                        <div className='flex flex-row gap-[var(--smGap)] justify-around ml-[var(--mleft)]'>
                                            <img className='aspect-square h-[calc(var(--lgFs))]' src={SketIcon} alt='SketIcon' />
                                            <span>{t('BUTTON_PUBLISH')}</span>
                                        </div>
                                        {sketchUploading && sketchModelUrl && <div id='publishBoard' className='absolute cursor-default flex flex-col py-4 px-4 bg-white left-0 bottom-[calc(4*var(--lgGap))] [box-shadow:0px_2px_12px_0px_#4A00E033] [transition:all_0.3s_ease] rounded-lg z-[99999]'>
                                            <span className='block font-[Arial] [font-size:calc(var(--lgFs))] font-semibold leading-6 text-center text-[#2D2D2D]'>Success</span>
                                            <span className='block font-[Arial] [font-size:var(--smFs)] font-normal leading-4 text-left text-[#909090] mt-[var(--smGap)] whitespace-nowrap'>Your model is now live on Sketchfab</span>
                                            <button onClick={() => {
                                                const link = document.createElement('a')
                                                link.href = sketchModelUrl
                                                link.target = '_blank'
                                                link.click()
                                            }} className='bg-[#4A00E0] font-[Arial] [font-size:var(--smFs)] font-normal leading-4 text-center text-[#ffffff] rounded-md py-3 mt-[var(--lgGap)] [transition:all_0.3s_ease] hover:bg-[#6214FF]'>View Model on Sketchfab</button>
                                            <span className='block mt-[var(--lgGap)] font-[Arial] [font-size:var(--midFs)] font-normal leading-4 text-left text-[#C2C2C2]'>SHARE URL</span>
                                            <input id='sketchurl' onClick={() => { setSketchHover(true); const d = document.getElementById('sketchurl'); d.select(); document.execCommand('copy'); }} type='text' readOnly='readonly' value={sketchModelUrl} className="relative mt-[var(--smGap)] border-[1px] border-solid border-[#C2C2C2] font-[Arial] [font-size:var(--smFs)] font-normal leading-4 text-left text-[#2D2D2D] rounded-md py-3 px-3 "></input>
                                            <div className={`p-1 bg-[rgba(212,212,212,1)] absolute bottom-5 right-1 text-[#969696] [font-size:var(--smFs)] mb-[2.2rem] rounded [transition:all_0.3s_ease]
                                            after:content-[""] after:absolute after:left-0 after:bottom-[-0.6rem] after:w-[12px] after:h-[12px] after:[border-top-color:rgba(212,212,212,1)] after:border-[6px] after:border-solid after:border-[transparent]
                                            ${sketchHover ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>Copied</div>
                                        </div>}
                                        {sketchUploading && !sketchModelUrl && <div id='publishBoard' className='absolute cursor-default flex flex-col justify-center items-center  py-4 w-[100%] bg-white left-0 bottom-[calc(4*var(--lgGap))] [box-shadow:0px_2px_12px_0px_#4A00E033] [transition:all_0.3s_ease] rounded-lg z-[999]'>
                                            <BiLoaderAlt className="w-[calc(4*var(--lgFs))] h-[calc(4*var(--lgFs))] animate-spin" />
                                            <div className='absolute inset-auto text-[var(--lgFs)]'>{sketchProcess}%</div>
                                        </div>}
                                    </div>}
                                </Restricted>
                                <div onClick={() => { handleDownload() }} ref={downloadRef} className={`${style.downloadBtn} ${genPipeline?.taskInfo?.restore?.data?.viewOnly && taskDetail?.user_state === "DonePreview" ? style.credits : ""}`}
                                    onMouseEnter={handleShowCredits}
                                    onMouseLeave={handleCloseCredits}>
                                    <span className={style.confirmSpan}>{packBtnInfo}</span>
                                </div>
                            </div>
                        )
                    }
                </div>
            )}

            <Turnstile ref={turnstileRef} siteKey='0x4AAAAAAAhbdFXzdFzkoDOV'
                style={{ display: "none" }}
                options={{ appearance: 'interaction-only', execution: 'execute' }} />

        </div>
    );
});
RodinPack.displayName = 'RodinPack'
export default RodinPack